import { useQuery } from '@tanstack/react-query';

import { productFiltersQuery } from './productFiltersQuery';

export const useProductFilters = (
  categorySlug?: string,
  search?: string,
  promotionId?: string,
  enabled = true,
) => useQuery({ ...productFiltersQuery(categorySlug, search, promotionId), enabled });
